import React, { Component as ReactComponent } from "react"
import { FunctionComponent } from "react"
import { Redirect, Route, RouteComponentProps } from "react-router"
import { routes } from "../../shared/constants"
import { SingleLoginStore } from "../../store/rootStore"
import { connect } from "react-redux"

export interface Props {
    component: ReactComponent,
    username: string,
    path: string
}

const ProtectedRoute: FunctionComponent<Props> = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props: RouteComponentProps) => (
            rest.username
                // @ts-ignore
                ? <Component {...props} />
                : <Redirect to={routes.USERNAME_FORM} />
        )}
    />
)

const mapStateToProps = (state: SingleLoginStore) => ({
    username: state.login.username
})

const UsernameProtectedRoute: FunctionComponent<any> = connect(mapStateToProps)(ProtectedRoute)
export default UsernameProtectedRoute
